import { render, staticRenderFns } from "./DetailHasilUjian.vue?vue&type=template&id=0c4775fb"
import script from "./DetailHasilUjian.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjian.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilUjian.vue?vue&type=style&index=0&id=0c4775fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports